import { axiosInstance } from "../core/http";

export const liveApi = {
  getAll: (page = 1) => axiosInstance.get("/api/live", { params: { page } }),
  create: (playground_id, start, duration) =>
    axiosInstance.post("/api/live", {
      playground_id,
      start,
      ...(duration != null ? { duration } : {}),
    }),
  getById: (id) => axiosInstance.put(`/api/live/${id}`),
  delete: (id) => axiosInstance.delete(`/api/live/${id}`),
  cut: (liveId, orderId, start, end, pipelinePassing, leftColor, rightColor, matchTime) =>
    axiosInstance.post(`/api/live/${liveId}/cut/`, {
      order_id: orderId,
      time_ranges: [{ start, end }],
      pipeline_passing: pipelinePassing,
      left_side_jersey_color: leftColor,
      right_side_jersey_color: rightColor,
      match_time: matchTime,
    }),
};
